import { Glue42 } from "../glue";

interface CallDetails {
    date: Date;
    config: Glue42.Config;
}

export class FactoryCallInfo {

    public promise: Promise<Glue42.Glue>;
    public initialized = false;
    public details: CallDetails[] = [];
    public reject: (reason?: any) => void = () => { /** Do nothing - default impl. - will be replaced */};
    public resolve: (value: Glue42.Glue | PromiseLike<Glue42.Glue>) => void = () => { /** Do nothing - default impl. - will be replaced */};

    public init(config: Glue42.Config) {
        this.initialized = true;
        this.addCall(config);
        this.promise = new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });
    }

    public addCall(config: Glue42.Config) {
        this.details.push({ date: new Date(), config });
    }

    public done(g: Glue42.Glue) {
        this.resolve(g);
    }

    public error(e: Error) {
        this.reject(e);
    }
}
